import { BaseError } from '@hsp/utilities';

import { s } from 'utilities/strings';

export class TokenInvalidError extends BaseError {
  constructor() {
    super(s('Api.Token.Invalid'));
  }
}
